/**
 * CEC-692. ¿Sigue el foco dentro del editor de términos, en su texto, su barra o un desplegable de la barra?
 *
 * Quill avisa de «blur» en cuanto el texto pierde la selección, también cuando el usuario abre un
 * desplegable de la barra (tamaño, color, fuente, alineación…): sus etiquetas son enfocables y se llevan
 * el foco. El componente cerraba el editor en ese momento y el formato no llegaba a aplicarse. Si el foco
 * sigue dentro del bloque del editor, no es una salida y no hay que cerrar: Quill devuelve el foco al
 * texto al elegir la opción.
 */
export function focusStaysInsideEditor(
  editorHost: Element | null | undefined,
  activeElement: Element | null | undefined,
): boolean {
  return !!editorHost && !!activeElement && editorHost.contains(activeElement);
}
